import cn from 'classnames';
// UI
import MillionsIcon from 'ui3/MillionsIcon/MillionsIcon';
import Modal from 'ui3/Modal/Modal';

import styles from './SearchBarToggle.module.scss';

type SearchBarToggleProps = {
  searchBarModalIsVisible: boolean;
  toggleSearchBarVisibility: () => void;
  className?: string;
  children?: JSX.Element;
  /** When true, modal container gets extra top padding on mobile when smart app banner is visible. */
  addSmartBannerPaddingToModal?: boolean;
};

const SearchBarToggle: React.FC<SearchBarToggleProps> = ({
  searchBarModalIsVisible,
  toggleSearchBarVisibility,
  children,
  className,
  addSmartBannerPaddingToModal = false,
}) => {
  return (
    <>
      <button
        className={cn(styles.searchBarToggleButton, className)}
        onClick={toggleSearchBarVisibility}
        type="button"
        aria-label="Search"
      >
        <MillionsIcon
          name="search"
          className={styles.searchBarToggleButtonIcon}
        />
      </button>

      <Modal
        size="medium"
        className={styles.searchBarToggleModal}
        open={searchBarModalIsVisible}
        onClose={toggleSearchBarVisibility}
        focusTrapped={false}
        fullPageOnMobile
        containerClassName={
          addSmartBannerPaddingToModal
            ? 'filtersModalWithSmartBannerPadding'
            : undefined
        }
      >
        {children}
      </Modal>
    </>
  );
};

export default SearchBarToggle;
